import { action, computed, thunk } from "easy-peasy";
import api from "./service";

const Users = {
    rules: [],
    countries: [],
    ruleById: {},
    allRules: [],

    detectedLocation: {},
    setRules: action((state, payload) => {
        state.rules = payload;
    }),
    setDetectedLocation: action((state, payload) => {
        state.detectedLocation = payload;
    }),
    setAllRules: action((state, payload) => {
        state.allRules = payload;
    }),
    setCountries: action((state, payload) => {
        state.countries = payload;
    }),
    setRuleById: action((state, payload) => {
        state.ruleById = payload;
    }),
    detectLocation: thunk(async (actions, payload = {}, { dispatch }) => {
        const { audit = true } = payload;
        return await api
            .detectLocation(payload)
            .then((response) => {
                const data = response?.data?.data;
                audit && actions.setDetectedLocation({
                    success: true,
                    countryCode: data.country?.isoCode || "",
                    countryName: data.country?.names?.en || "",
                    ip: data.traits?.ipAddress || "",
                    service: "MaxMind GeoLite2",
                    city: data.city?.names?.en,
                    region: data.subdivisions?.[0]?.names?.en,
                    postal: data.postal?.code,
                    continent: data.continent?.names?.en,
                    latitude: data.location?.latitude,
                    longitude: data.location?.longitude,
                    timeZone: data.location?.timeZone,
                    stateCode: data.subdivisions?.[0]?.isoCode,
                    stateName: data.subdivisions?.[0]?.names?.en,
                    error: "", // Add empty error string
                    traits: {
                        isAnonymousProxy: data.traits?.isAnonymousProxy || false,
                        isSatelliteProvider: data.traits?.isSatelliteProvider || false,
                        network: data.traits?.network,
                        autonomousSystemNumber: data.traits?.autonomousSystemNumber,
                        autonomousSystemOrganization:
                            data.traits?.autonomousSystemOrganization,
                    },
                });
                return Promise.resolve(response);
            })
            .catch((error) => {
                console.log("ERR", error);
                // !audit && dispatch?.app?.audit?.set({ type: "error", log: error });
                return Promise.reject(error);
            });
    }),

    getAllCountries: thunk(async (actions, payload = {}, { dispatch }) => {
        const { audit = true } = payload;
        return await api
            .getAllCountries(payload)
            .then((response) => {
                audit && actions.setCountries(response?.data?.data);
                return Promise.resolve(response);
            })
            .catch((error) => {
                console.log("ERR", error);
                // !audit && dispatch?.app?.audit?.set({ type: "error", log: error });
                return Promise.reject(error);
            });
    }),



    getAllRules: thunk(async (actions, payload = {}, { dispatch }) => {
        const { audit = true } = payload;
        return await api
            .getAllRules(payload)
            .then((response) => {
                audit && actions.setAllRules(response?.data?.data?.rules);
                return Promise.resolve(response);
            })
            .catch((error) => {
                console.log("ERR", error);
                // !audit && dispatch?.app?.audit?.set({ type: "error", log: error });
                return Promise.reject(error);
            });
    }),
    getRuleById: thunk(async (actions, payload = {}, { dispatch }) => {
        const { audit = true } = payload;
        return await api
            .getRuleById(payload)
            .then((response) => {
                audit && actions.setRuleById(response?.data?.data);
                return Promise.resolve(response);
            })
            .catch((error) => {
                console.log("ERR", error);
                // !audit && dispatch?.app?.audit?.set({ type: "error", log: error });
                return Promise.reject(error);
            });
    }),



};

export default Users;
